import { Input, isDevMode, Component, OnInit } from '@angular/core';
import { MainMenuItem, MenuService } from '../menu.service';
import { ChatbotDialog } from '@wephone-common/modals';
import { DialogService } from '@wephone-utils';

@Component({
  selector: 'app-base-menu',
  templateUrl: './base-menu.component.html',
  styleUrls: ['./base-menu.component.scss'],
  providers: [MenuService]
})
export class BaseMenuComponent implements OnInit {
  @Input() menuItems: MainMenuItem[] = [];

  menus: MainMenuItem[] = [];
  devMode = false;
  constructor(
    private readonly menuService: MenuService,
    private readonly dialogService: DialogService
  ) {
    this.devMode = isDevMode();
  }

  ngOnInit(): void {
    console.log('BaseComponent initialized');
    this.onInit();
  }

  protected onInit(): void {
    this.menus = [];
    for (const menuItem of this.menuItems) {
      const item = menuItem;
      if (this.menuItemVisible(menuItem)) {
        const children = [];
        if (item.children) {
          for (const child of item.children) {
            if (this.menuItemVisible(child)) {
              children.push(child);
            }
          }
        }

        item.children = children;
      } else {
        continue;
      }

      this.menus.push(item);
    }
  }

  private menuItemVisible(menuItem: MainMenuItem): boolean {
    return this.menuService.showMenuItem(menuItem);
  }

  openChatbotDialog(): void {
    this.dialogService.openModal(ChatbotDialog, { size: 's', height: '580px' });
  }
}
